<template>
  <div class="productRegister" :class="{ open: Store.state.productRegisterModal.open }">
    <!-- <svgicon name="mail-stamp" /> -->
    <div class="strip strip--bottom"></div>
    <div class="strip strip--top"></div>
    <div class="submitting" v-show="submitting">
      <div class="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
    </div>
    <div class="close" @click="toggleProductRegisterModal()">
      Close
      <svgicon
        class="std-grey pos-rel -top-2"
        name="close"
        width="13"
        height="13"
        title="Close contact form."
      />
    </div>
    <div class="productRegisterWrap">
      <div class="productRegisterForm confirmation" v-show="emailSent">
        <svgicon class="" name="check" width="30" height="30" />
        <div class="heading">
          Email sent successfully
        </div>
        <p class="copy-md text-center">
          Check your inbox to access your download link.
        </p>
      </div>
      <div class="productRegisterForm" v-show="!emailSent">
        <svgicon class="std-grey" name="message" width="30" height="30" :fill="true" />
        <div class="heading">
          Register for download
        </div>
        <p class="copy-sm">
          On submission, you will be sent a link to your email address in which you can download the
          software.
        </p>
        <form @submit.prevent="processForm">
          <div class="formFields">
            <fieldset class="full" :class="{ error: errors.indexOf('name') !== -1 }">
              <label for="name" class="required">
                Name
                <div class="inputWrap">
                  <input type="text" name="name" id="name" requried v-model="name" />
                </div>
              </label>
            </fieldset>

            <fieldset class="full" :class="{ error: errors.indexOf('name') !== -1 }">
              <label for="organisation" class="required">
                Organisation Name
                <div class="inputWrap">
                  <input
                    type="text"
                    name="organisation"
                    id="organisation"
                    requried
                    v-model="organisation"
                  />
                </div>
              </label>
            </fieldset>

            <fieldset class="full" :class="{ error: errors.indexOf('title') !== -1 }">
              <label for="title" class="required">
                Title/Role
                <div class="inputWrap">
                  <input type="text" name="title" id="title" requried v-model="title" />
                </div>
              </label>
            </fieldset>

            <fieldset class="full" :class="{ error: errors.indexOf('country') !== -1 }">
              <label for="country" class="required">
                Country
                <div class="inputWrap">
                  <select name="country" id="country" requried v-model="country">
                    <option
                      v-for="country in countries"
                      v-bind:value="country.id"
                      :key="country.id"
                    >
                      {{ country.text }}
                    </option>
                  </select>
                </div>
              </label>
            </fieldset>

            <fieldset class="full" :class="{ error: errors.indexOf('email') !== -1 }">
              <label for="email" class="required">
                Email address
                <div class="inputWrap">
                  <input type="email" name="email" id="email" requried v-model="email" />
                </div>
              </label>
            </fieldset>

            <fieldset class="full" :class="{ error: errors.indexOf('phone') !== -1 }">
              <label for="phone" class="required">
                Phone number
                <div class="inputWrap">
                  <input type="phone" name="phone" id="phone" requried v-model="phone" />
                </div>
              </label>
            </fieldset>

            <fieldset class="full">
              <div id="g-recaptcha-cis"></div>
            </fieldset>

            <fieldset class="full">
              <div class="p-1" style="display: flex">
                <input
                  class="inputWrap"
                  type="checkbox"
                  name="contactMe"
                  id="contactMe"
                  requried
                  v-model="contactMe"
                  style="margin: auto"
                />
                <label class="p-3 copy-sm" for="contactMe">
                  I'd like someone from Pipefish to contact me to discuss helping me
                  configuring/customising my Lansweeper/ServiceNow integration
                </label>
              </div>
            </fieldset>
          </div>
          <div class="formMessages" id="error-message" v-if="errorMsg">
            <div class="formMessages--error" v-html="errorMsg"></div>
          </div>
          <div class="formButtons">
            <button type="submit" class="submit" :disabled="submitting">
              Register for Download
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
/* global grecaptcha */
import axios from 'axios';
import '@/components/svg/message-outline';
import countries from '../countries.js';
export default {
  name: 'ProductRegister',
  components: {},
  data: function() {
    return {
      emailSent: false,
      gRec: '',
      captchaValid: false,
      submitting: false,
      countries
    };
  },
  mounted: function() {
    var vm = this;

    function capCallback(response) {
      vm.gRec = response;
      vm.captchaValid = true;
    }
    let parameters = {
      sitekey: '6Lds7aAUAAAAAGYFrahJAxEsGtRljY0yXRTcxbXg',

      callback: capCallback
    };

    setTimeout(function() {
      if (vm.$utils.isDefined(grecaptcha)) {
        grecaptcha.render('g-recaptcha-cis', parameters);
      }
    }, 600);
  },
  watch: {
    name: function() {
      if (this.errors.indexOf('name') !== -1) {
        this.errors.splice(this.errors.indexOf('name'), 1);
      }
    },
    email: function() {
      if (this.errors.indexOf('email') !== -1) {
        this.errors.splice(this.errors.indexOf('email'), 1);
      }
    },
    phone: function() {
      if (this.errors.indexOf('phone') !== -1) {
        this.errors.splice(this.errors.indexOf('phone'), 1);
      }
    },
    organisation: function() {
      if (this.errors.indexOf('organisation') !== -1) {
        this.errors.splice(this.errors.indexOf('organisation'), 1);
      }
    },
    title: function() {
      if (this.errors.indexOf('title') !== -1) {
        this.errors.splice(this.errors.indexOf('title'), 1);
      }
    },
    country: function() {
      if (this.errors.indexOf('country') !== -1) {
        this.errors.splice(this.errors.indexOf('country'), 1);
      }
    },
    contactMe: function() {
      if (this.errors.indexOf('contactMe') !== -1) {
        this.errors.splice(this.errors.indexOf('contactMe'), 1);
      }
    }
  },
  computed: {
    modal: {
      get: function() {
        return this.Store.state.productRegisterModal;
      },
      set: function() {}
    },
    standardErrorMessage: {
      get: function() {
        return `Oh... awkward. It looks like there was a problem sending your message.
        Please contact us via
        <a href="mailto:info@pipefish.com.au?subject=${
          this.Store.state.productRegisterModal.productName
        } register form">
        info@pipefish.com.au</a> while we take a look at it.`;
      },
      set: function() {}
    },
    name: {
      get: function() {
        return this.Store.state.productRegisterModal.name;
      },
      set: function(newValue) {
        this.Store.state.productRegisterModal.name = newValue;
      }
    },
    organisation: {
      get: function() {
        return this.Store.state.productRegisterModal.organisation;
      },
      set: function(newValue) {
        this.Store.state.productRegisterModal.organisation = newValue;
      }
    },
    title: {
      get: function() {
        return this.Store.state.productRegisterModal.title;
      },
      set: function(newValue) {
        this.Store.state.productRegisterModal.title = newValue;
      }
    },
    country: {
      get: function() {
        return this.Store.state.productRegisterModal.country;
      },
      set: function(newValue) {
        this.Store.state.productRegisterModal.country = newValue;
      }
    },
    email: {
      get: function() {
        return this.Store.state.productRegisterModal.email;
      },
      set: function(newValue) {
        this.Store.state.productRegisterModal.email = newValue;
      }
    },
    phone: {
      get: function() {
        return this.Store.state.productRegisterModal.phone;
      },
      set: function(newValue) {
        this.Store.state.productRegisterModal.phone = newValue;
      }
    },
    contactMe: {
      get: function() {
        return this.Store.state.productRegisterModal.contactMe;
      },
      set: function(newValue) {
        this.Store.state.productRegisterModal.contactMe = newValue;
      }
    },
    errors: {
      get: function() {
        return this.Store.state.productRegisterModal.errors;
      },
      set: function(newState) {
        this.Store.state.productRegisterModal.errors = newState;
      }
    },
    emailSent: {
      get: function() {
        return this.Store.state.productRegisterModal.emailSent;
      },
      set: function(newValue) {
        return (this.Store.state.productRegisterModal.emailSent = newValue);
      }
    },
    errorMsg: {
      get: function() {
        return this.Store.state.productRegisterModal.errorMsg;
      },
      set: function(newValue) {
        return (this.Store.state.productRegisterModal.errorMsg = newValue);
      }
    }
  },
  methods: {
    toggleProductRegisterModal: function() {
      this.$utils.log(['-----toggleProductRegisterModal()']);
      if (!this.emailSent) {
        this.resetCaptcha();
        this.Store.toggleProductRegisterModal();
        // this.Store.dispatch('toggleProductRegisterModal');
      } else {
        this.Store.resetProductRegisterData();
        this.Store.closeProductRegisterModal();
      }
    },
    validateForm: function() {
      var valid = true;
      if (!this.$utils.isDefined(this.name)) {
        if (this.errors.indexOf('name') === -1) {
          this.errors.push('name');
        }
        valid = false;
      }
      if (!this.$utils.isDefined(this.email)) {
        if (this.errors.indexOf('email') === -1) {
          this.errors.push('email');
        }
        valid = false;
      }

      if (!this.$utils.isDefined(this.organisation)) {
        if (this.errors.indexOf('organisation') === -1) {
          this.errors.push('organisation');
        }
        valid = false;
      }

      if (!this.$utils.isDefined(this.title)) {
        if (this.errors.indexOf('title') === -1) {
          this.errors.push('title');
        }
        valid = false;
      }

      if (!this.$utils.isDefined(this.country)) {
        if (this.errors.indexOf('country') === -1) {
          this.errors.push('country');
        }
        valid = false;
      }
      if (!this.captchaValid) {
        // valid = false;
      }
      return valid;
    },
    processForm: function() {
      var vm = this;
      if (!this.validateForm()) {
        return false;
      }

      vm.submitting = true;

      vm.errorMsg = null;
      var postData = new URLSearchParams();
      postData.append('gRec', vm.gRec);
      postData.append('productName', vm.Store.state.productRegisterModal.productName);
      postData.append('name', vm.name);
      postData.append('email', vm.email);
      postData.append('title', vm.title);
      postData.append('organisation', vm.organisation);
      postData.append('country', vm.country);
      postData.append('phone', vm.phone);
      postData.append('contactMe', vm.contactMe);

      var options = {};
      axios
        .post('/.netlify/functions/register-product', postData, options)
        .then(function(res) {
          if (res.data.success) {
            vm.confirmation = true;
            vm.emailSent = true;
            vm.submitting = false;
            vm.resetCaptcha();
            vm.Store.resetProductRegisterData();
          } else if (!res.data.success) {
            vm.confirmation = false;
            vm.resetCaptcha();
            vm.submitting = false;
            vm.errorMsg = res.data.message || vm.standardErrorMessage;
          }
        })
        .catch(function(error) {
          vm.submitting = false;

          if (error.response.data && error.response.data.message) {
            vm.errorMsg = error.response.data.message;
          } else {
            vm.errorMsg = vm.standardErrorMessage;
          }
        });
    },
    resetCaptcha: function() {
      // if (this.isProd()) {
      if (this.$utils.isDefined(grecaptcha)) {
        grecaptcha.reset();
      }
      this.gRec = '';
      this.captchaValid = false;
      // }
    },
    isProd: function() {
      // stage or prod
      return location.hostname.indexOf('pipefish.com.au') !== -1;
    }
  }
};
</script>

<style lang="scss">
.productRegister {
  @include rtp_transition($property: 'transform', $duration: 0.3s);
  box-shadow: 0px 3px 30px rgba(0, 0, 0, 0.3);
  position: fixed;
  background: rgba(#fff, 1);
  z-index: 900 010;
  max-width: 740px;
  border-radius: 2px;
  transform: translateX(0%) translateY(130%);
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
  overflow: hidden;
  z-index: 999999;
  &.open {
    transform: translateY(0%);
  }
  @include media('>=750px') {
    top: 40px;
    bottom: 40px;
    left: 50%;
    min-width: 700px;
    transform: translateX(-50%) translateY(130%);
    &.open {
      transform: translateX(-50%) translateY(0%);
    }
  }

  .submitting {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(#fff, 0.9);
    z-index: 200;
    .spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }

  .close {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 16px;
    font-family: $brand-font-family;
    color: $Grey3;
    vertical-align: middle;
    cursor: pointer;
    z-index: 100;
    width: 60px;
    @include media('>450px') {
      top: 30px;
    }
    svg {
      vertical-align: middle;
      position: absolute;
      top: 5px;
      right: 0;
      path,
      g {
        stroke: $Grey3;
      }
    }
    &:hover {
      color: $LogoOrange1;
      svg {
        path,
        g {
          stroke: $LogoOrange1;
        }
      }
    }
  }

  .productRegisterWrap {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow-y: auto;
    background-image: url(~@/assets/svg/mail-stamp.svg);
    background-repeat: no-repeat;
    background-size: 48%;
    background-position: -9% 13%;

    // background-position: -200px 25%;
    // background-size: 90%;

    // @include media('<medium') {
    //   background-size: 80%;
    // }

    .productRegisterForm {
      width: 100%;
      max-width: 740px;
      margin: 0 auto;
      padding: 20px;
      padding-top: 35px;

      // top: 50%;
      // position: absolute;
      // transform: translateY(-50%);

      @include media('>450px') {
        padding: 30px;
      }

      .heading {
        font-family: $brand-font-family;
        color: $Grey5Chicago;

        font-size: 20px;
        line-height: 1em;
        margin: 0;
        padding: 10px 0 10px 0;
        position: relative;
        font-weight: 600;

        @include media('>450px') {
          font-size: 20px;
          line-height: 1em;
          margin: 0;
          padding: 30px 0 20px 38px;
          position: relative;
          font-weight: 600;
        }

        @include media('>450px') {
          font-size: 35px;
          margin: 0 0 10px 0;
          // padding: 33px 0 30px 45px;

          text-align: center;
          padding: 85px 0 30px 0px;
        }
      }

      svg {
        display: none;
        path {
          fill: #ddd;
        }
        //TODO
        @include media('>320px') {
          position: absolute;
          left: 0;
          top: 23px;
          // display: block;
        }
        @include media('>450px') {
          width: 50px !important;
          height: 50px !important;
          top: 50px;
          left: 50%;
          transform: translateX(-50%);
          display: block;
        }
      }

      &.confirmation {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        svg {
          display: none;
          @include media('>320px') {
            display: block;
          }
          top: 35px;
          width: 70px !important;
          height: 70px !important;
          fill: green !important;
        }
        .heading {
        }
      }

      .formFields {
        $fieldPadding: 5px;

        display: flex;
        flex-wrap: wrap;
        margin-left: 0 - ($fieldPadding * 2);
        margin-right: 0 - ($fieldPadding * 2);

        fieldset {
          display: flex;
          width: 100%;
          // background: #eee;
          padding: 0px 10px;
          margin: 0;
          border: 0;

          @include media('>550px') {
            // padding: 5px 10px;
            width: 50%;
          }

          &.error {
            // border: 1px solid red;
            label {
              color: red;
            }
            .inputWrap {
              border-color: red;
            }
          }

          label {
            font-family: $brand-font-family;
            font-size: 16px;
            display: block;
            width: 100%;
            padding: 0 0 0 0;
            display: block;
            &:active,
            &:focus {
              color: $PriBlueLight;
            }
          }

          &.full {
            width: 100%;
          }

          $inputHeight: 45px;
          .inputWrap {
            background: #fff;
            border-bottom: 1px solid #333;
            // height: $inputHeight;
            padding: 0px;
            margin: 3px 0;
            border: 1px solid #ddd;
            border-radius: 2px;
            clear: left;

            &:active,
            &:focus {
              border-color: $PriBlueLight;
            }
            input,
            select,
            textarea {
              background: #fff;
              border: none;
              font-size: 17px;
              padding: 10px 10px;
              width: 100%;
              border-radius: 0px;
              height: $inputHeight - 5px;
              display: block;
              width: 100%;
              @include media('>450px') {
                height: $inputHeight - 1px;
              }
              &:active,
              &:focus {
                background: #ffee;
              }
            }
            select {
              width: 100%;
              -webkit-appearance: none;
            }
            textarea {
              // margin-bottom: -4px;
              height: $inputHeight * 1.5;
              // min-height: $inputHeight - 1px;
            }
          }
        }
      }

      #g-recaptcha-cis {
        margin: 5px 0;
        @include media('>450px') {
          margin: 10px 0;
        }
        > div {
          margin: 0 auto;
        }
      }

      .formButtons {
        text-align: center;
        button.submit {
          padding: 10px 10px;
          width: 100%;
          margin: 5px auto;
          border: none;
          background: $LogoOrange1;
          color: #fff;
          text-transform: uppercase;
          font-size: 14px;
          font-weight: 600;
          border-radius: 2px;

          &:hover,
          &:focus {
            background: darken($LogoOrange1, 10%);
          }
          &:active {
            background: daken($LogoOrange1, 20%);
          }

          @include media('>450px') {
            padding: 15px 10px;
            width: 200px;
          }
        }
      }

      .formMessages {
        text-align: center;
        border: 1px solid lighten(red, 5%);
        background: lighten(red, 45%);
        color: lighten(red, 20%);
        padding: 10px;
        font-size: 14px;
        line-height: 1.3em;
        border-radius: 2px;
        a {
          color: red;
        }
      }
    }
  }
  .strip {
    position: absolute;
    z-index: 20;
    height: 13px;
    background-color: #fff;
    background-image: url(~@/assets/svg/airmail-strip.svg);
    background-repeat: repeat-x;
    background-size: cover;

    &--top {
      top: -1px;
      left: 0;
      right: 0;
    }
    &--bottom {
      bottom: -1px;
      left: 0;
      right: 0;
      transform: rotateX(180deg);
      background-position: 88% 0;
    }
  }
}
</style>
